const UPDATES = [
  { date: '07.28', tag: '新作上线', title: '《星海归途》正式登陆新新漫画', desc: '国漫科幻新星之作，首日即登分类热度榜前三，画风华丽剧情硬核。' },
  { date: '07.26', tag: '更新提醒', title: '《某天成为公主》第 132 话更新', desc: '本周最受期待的章节更新，皇室舞会情节迎来重大转折点。' },
  { date: '07.25', tag: '平台公告', title: '新新漫画服务器全面升级完成', desc: '阅读加载速度提升 40%，图片清晰度全面优化，追更体验再上新台阶。' },
  { date: '07.23', tag: '专题上线', title: '「夏日奇幻祭」专题活动开启', desc: '奇幻分类作品限时推荐，参与互动讨论有机会获得限定头像框。' },
  { date: '07.21', tag: '新作上线', title: '《大理寺日志》第三季全网同步', desc: '国漫悬疑代表作新季回归，大理寺众人再度集结破解奇案。' },
  { date: '07.18', tag: '漫友活动', title: '「我画你猜」漫画角色问答赛', desc: '趣味问答活动火热进行中，猜中 10 题即可获得专属"漫痴"称号徽章。' },
  { date: '07.15', tag: '更新提醒', title: '《一人之下》新章开启，世界观再扩张', desc: '张楚岚一行人踏入全新领域，神秘势力的面纱正在逐渐揭开。' },
  { date: '07.12', tag: '合作官宣', title: '新新漫画与韩国 TOP 漫画平台达成合作', desc: '更多优质韩漫正版引进，未来将陆续上线超 100 部独家授权作品。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          新新漫画的大事小情，第一时间告诉你
        </p>
        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-6">
            {UPDATES.map((item) => (
              <div key={item.title} className="relative flex gap-4 pl-10">
                <div className="absolute left-0 top-1 w-[38px] h-[38px] rounded-full bg-primary-100 border-4 border-background-50 flex items-center justify-center flex-shrink-0">
                  <div className={`w-2.5 h-2.5 rounded-full ${
                    item.tag === '新作上线' ? 'bg-accent-500' :
                    item.tag === '更新提醒' ? 'bg-primary-500' :
                    item.tag === '平台公告' ? 'bg-secondary-500' :
                    'bg-primary-400'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 border border-background-200/70">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-[12px] font-bold text-primary-500">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[11px] font-bold whitespace-nowrap ${
                      item.tag === '新作上线' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '更新提醒' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '平台公告' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-[14px] font-bold text-foreground-800 mb-1">{item.title}</h3>
                  <p className="text-[13px] leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}